import * as z from "zod";
import { mutator } from "./mutator";

const deleteUsagePriceSchema = z.object({
  id: z.string(),
});

export const deleteUsagePrice = mutator({
  schema: deleteUsagePriceSchema,
  resolve: {
    price: { kind: "connectorUsagePrice", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { price } }) => {
    await tx.mutate.connectorUsagePrices.delete({ id: price.id });
  },
});
